import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { CircularProgress, LinearProgress, Modal } from '@material-ui/core';
import { makeStyles, defaultTheme } from "../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    linearProgress: {
        zIndex: theme.zIndex.tooltip + 100,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
    },
    circularProgress: {
        width: 150,
        height: 50,
        margin: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none',
        userSelect: 'none',
    },
    lockModal: {
        display: 'flex',
        flexDirection: 'column',
        outline: 'none',
        userSelect: 'none',
    },
}); }, { name: 'SnLoadingScreen' });
var LOCK_BACKDROP_PROPS = {
    style: {
        backgroundColor: 'transparent',
    },
};
var COVER_BACKDROP_PROPS = {
    style: {
        backgroundColor: defaultTheme.palette.light.background.default,
    },
};
var usePrevious = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
};
/**
 * ローディング画面コンポーネント。
 */
export var LoadingScreen = function (props) {
    var loading = props.loading, lockScreen = props.lockScreen, coverScreen = props.coverScreen;
    var classes = useStyles(props);
    // モーダル付きローディング中はキーボードによる意図しない操作（エンター連打など）がされないようにFocusを奪い、
    // ローディング終了時にfocusを戻す。
    var openModal = coverScreen || lockScreen;
    var openModalPrev = usePrevious(openModal);
    var savedFocusElement = useRef(null);
    useEffect(function () {
        if (openModal && !openModalPrev) {
            savedFocusElement.current = document.activeElement;
            if (savedFocusElement.current instanceof HTMLElement) {
                savedFocusElement.current.blur();
            }
        }
        if (!openModal && openModalPrev) {
            if (savedFocusElement.current instanceof HTMLElement) {
                savedFocusElement.current.focus();
            }
            savedFocusElement.current = null;
        }
    });
    if (!loading) {
        return null;
    }
    if (coverScreen || lockScreen) {
        return (React.createElement(Modal, { disableEnforceFocus: true, disableAutoFocus: true, open: loading && (lockScreen || coverScreen), className: classes.lockModal, BackdropProps: coverScreen ? COVER_BACKDROP_PROPS : LOCK_BACKDROP_PROPS },
            React.createElement("div", { className: classNames(classes.circularProgress) },
                React.createElement(CircularProgress, null))));
    }
    return (React.createElement("div", { className: classNames(classes.linearProgress) },
        React.createElement(LinearProgress, { color: "primary" })));
};
